import useCompanies from './use-companies';

const useCompany = ({
  id = null, // gatsby
  strapiId = null, // v4
  documentId = null, // v5
} = {}) => {
  const companies = useCompanies();
  if (documentId) {
    return companies.find(({
      documentId: companyDocumentId,
    }) => companyDocumentId === documentId);
  }
  if (strapiId) {
    return companies.find(({
      strapiId: companyStrapiId,
    }) => companyStrapiId === Number(strapiId));
  }
  if (id) {
    return companies.find(({ id: companyId }) => companyId === id);
  }
  return companies[0];
};

export default useCompany;
